/**
 * Locales that are translated but not yet signed off, so they stay out of the
 * picker and are never picked up implicitly from navigator.language. Each is
 * reachable via the `i18nextLng` cookie (a funnel in that language sets it) or
 * `?lang=<code>`.
 *
 * Import-free on purpose: the SSR-safe content-locale helpers
 * (features/shared/locale.ts) read it without pulling in the i18n bundle.
 * pt_br and ar shipped once their `app.json` reached parity; it shipped after
 * its QA round on 2026-11-05. Empty until the next locale lands.
 */
export const UNRELEASED_LANGUAGES: readonly string[] = [];
